import React from "react";
import SearchIcon from "@mui/icons-material/Search";

const HubSearchIcon = () => (
  <SearchIcon
    sx={{
      fontSize: "1.125rem !important",
      color: "#98A2B3",
    }}
  />
);

export default HubSearchIcon;
